<template>
  <section class="section" id="track-and-trace">
    <div class="section-inner">
      <div class="column is-full">
        <Loading v-if="loading" />
        <router-view v-if="enabled" />
        <p v-else>{{ message }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { store } from '@/store'
import Loading from '@/components/Loading'

export default {
  name: 'App',
  data() {
    return {
      enabled: false,
      message: ''
    }
  },
  components: {
    Loading
  },
  computed: {
    loading() {
      return store.loading
    }
  },
  mounted() {
    if (window.appData.trackingEnabled) {
      this.enabled = true
    } else {
      this.enabled = false
      this.message = window.appData.message
    }
  }
}
</script>

<style>
  @media(min-width: 1024px) {
    .columns {
    display: flex;
    flex-direction: row;
    }
  }

  @media(max-width: 1023px) {
    .columns > * {
      margin-bottom: 1rem;
    }
  }

  .text-right {
    text-align: right;
  }
</style>